module.exports = __webpack_public_path__ + "static/media/badge10.828f0ea4.svg";